var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"preloader"}),_c('top-nav'),_c('router-view'),_c('foot-nav')],1),_c('div',{staticClass:"back-to-top scroll-to-target show-back-to-top",attrs:{"data-target":"html"}},[_vm._v("TOP")])])
}
var staticRenderFns = []

export { render, staticRenderFns }